import {
    AfterContentInit, AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output,
    ViewChild
} from '@angular/core';

@Component({
    selector: 'input-container',
    templateUrl: './input-container.component.html',
    providers: []
})
export class InputContainerComponent implements OnInit, AfterViewInit{

    @Input() placeholder;
    @Input() name;
    @Input() label;
    @Input() invalid;
    @Input() invalidText;
    @Input() disabled;
    @ViewChild("wcinput", {read: ElementRef}) child: ElementRef;
    @Output() onChange: EventEmitter<any> = new EventEmitter();
    @Output() onFocus: EventEmitter<any> = new EventEmitter();
    modelValue = "";
    @Output() modelChange:EventEmitter<any> = new EventEmitter<any>();
    value:any;

    constructor() {}

    @Input()
    get model() {
        return this.modelValue;
    }

    set model(val:any) {
        if(val != this.value){
            this.value=val;
        }
        if(val != this.child.nativeElement.value) {
            this.child.nativeElement.value  = val;
        }
        this.modelValue = val;
        this.modelChange.next(this.modelValue);
    }

    ngAfterViewInit(): void {
        this.child.nativeElement.addEventListener("change",(event) => {
            if(this.modelValue != event.target.value){
                this.modelValue = event.target.value;
                this.modelChange.next(event.target.value);
            }
            if(this.child.nativeElement.value != event.target.value) {
                this.child.nativeElement.value = event.target.value;
            }

        });
    }

    ngOnInit(): void {
        this.disabled=!!this.disabled?this.disabled:false;
        this.value = this.model;
        this.child.nativeElement.value = this.model;
    }

}



// WEBPACK FOOTER //
// ./public/upgrade/shared/input-container/input-container.component.ts